import React, { useState } from 'react';
import { LegalModal, type LegalDoc } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc>(null);
  return <>
      <footer className="bg-[#0a0a0a] border-t border-white/10 py-12" data-id="element-40">
        <div className="container mx-auto px-4 flex flex-col items-center text-center" data-id="element-41">
          <span className="font-serif text-xl font-semibold tracking-widest text-[#d4a437] mb-4" data-id="element-42">
            AFFILIATE WAVE
          </span>

          <p className="text-neutral-400 mb-6 font-medium" data-id="element-43">
            Comunidad oficial de Gus Sevilla
          </p>

          <div className="w-12 h-[1px] bg-white/20 mb-6" data-id="element-44"></div>

          <p className="text-neutral-500 text-sm max-w-md mx-auto mb-6" data-id="element-45">
            Marketing de afiliados profesional. Construye con estructura, no con
            improvisación.
          </p>

          <nav aria-label="Enlaces legales" className="flex items-center gap-6 mb-6" data-id="element-46">
            <button type="button" onClick={() => setOpenDoc('privacidad')} className="text-sm text-neutral-400 hover:text-[#d4a437] transition-colors focus-visible:outline-none focus-visible:text-[#d4a437] focus-visible:underline" data-id="element-47">
              Privacidad
            </button>
            <span className="w-1 h-1 rounded-full bg-white/20" aria-hidden="true" data-id="element-48"></span>
            <button type="button" onClick={() => setOpenDoc('terminos')} className="text-sm text-neutral-400 hover:text-[#d4a437] transition-colors focus-visible:outline-none focus-visible:text-[#d4a437] focus-visible:underline" data-id="element-49">
              Términos
            </button>
          </nav>

          <p className="text-neutral-600 text-xs" data-id="element-50">
            &copy; {new Date().getFullYear()} Affiliate Wave. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <LegalModal open={openDoc} onClose={() => setOpenDoc(null)} data-id="element-51" />
    </>;
}